import styled from 'styled-components'

import { Title } from '@/containers/styles'

export const EventHeadingWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const StyledTitle = styled(Title)`
  line-height: 1.2em;
  margin-bottom: 10px;
  padding-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
`
export const BodyTextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`
